import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class JobAreas extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                width: 330,
                height: 621,
                marginTop: 24,
                marginBottom: 30,
            },
            xAxis: {
                labels: {
                    // xAxis is labelled seperatly outside the chart
                    enabled: false
                },
                tickWidth: 0,
            },
            yAxis: {
                labels: {
                    y: 20,
                },
            }
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(JobAreas)}